module.exports = __webpack_public_path__ + "img/close.87bdf902.svg";